/**
 * @prettier
 * @flow
 */
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { translate } from 'src/utils/translate/translate';

export function FormMsiField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const classes = useStyles();

    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();

    return (
        <Controller
            render={({ onChange, ...props }) => (
                <Autocomplete
                    freeSolo={false}
                    autoSelect={true}
                    options={options}
                    getOptionLabel={option => option}
                    renderInput={params => <TextField {...params} label={label} placeholder={translate('No promotion')} variant={variant} error={!!errors[name]} InputLabelProps={{ shrink: true }} />}
                    onChange={(e, data) => onChange(data)}
                    {...props}
                />
            )}
            name={name}
            rules={{
                required: {
                    value: rules?.required,
                    message: translate('This field is required'),
                },
            }}
            InputProps={InputProps}
            value={value}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            onChange={([, data]) => data}
            defaultValue={defaultValue}
            control={control}
        />
    );
}

const options = ['3', '6', '9', '12', '18'];

const useStyles = makeStyles(theme => ({}));

export type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
        minLength?: number | { message: string, value: number },
        maxLength?: number | { message: string, value: number },
    |},
    InputProps?: any,
    defaultValue?: string,
|};
